import { IConsoleSearchParams } from '@epicuro-next/data/product';
import {
  IDynamicInput,
  IDynamicItem,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { Observable } from 'rxjs';

export enum LinkType {
  LINK = 'link',
  SEARCH = 'search',
  BLANK = '',
  PRODUCT_LIST = 'productList',
  LOOK_BOOK = 'lookbook',
  PANEL = 'panel',
}

interface ILinkBase<T extends LinkType> {
  type: T;
  label?: string;
  image?: string;
  video?: {
    posterImage: string;
    url: string;
  };
  style?: {
    color: string;
    position: string;
  };
  fullScreen?: string;
}

export const enum LinkSortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export interface IBlankLink extends ILinkBase<LinkType.BLANK> {
  params?: {} | null;
  linkParams?: {} | null;
}

export interface ILinkParams {
  href?: string;
  sref?: string;
}

export interface IFullLink extends ILinkBase<LinkType.LINK> {
  params?: {} | null;
  linkParams: ILinkParams;
}

export interface ISearchLink extends ILinkBase<LinkType.SEARCH> {
  params: IConsoleSearchParams;
  linkParams?: {};
}

export interface IProductListLink extends ILinkBase<LinkType.PRODUCT_LIST> {
  params: null;
  linkParams: { productList: string };
}

export interface ILookBooktLink extends ILinkBase<LinkType.LOOK_BOOK> {
  params: null;
  linkParams: { lookbookId: string; productList?: string };
}

export type PanelParams = {
  panelName: string;
  arguments?: { [key: string]: IDynamicInput };
  fallbackPanel?: PanelParams;
};

export interface IPanelLink extends ILinkBase<LinkType.PANEL> {
  params: PanelParams;
  panelContent$?: Observable<{
    panel: IDynamicItem[];
    fallbackPanel?: IDynamicItem[];
  }>;
}

export function isIPanelLink(value: unknown): value is IPanelLink {
  if (value === undefined || value === null || typeof value !== 'object') {
    return false;
  }
  const typeKey: keyof ILinkBase<LinkType.PANEL> = 'type';
  return typeKey in value && value.type === LinkType.PANEL;
}

export type ILink =
  | IFullLink
  | ISearchLink
  | IBlankLink
  | IProductListLink
  | ILookBooktLink
  | IPanelLink;

interface ITileLinkBase {
  title?: string;
  subtitle?: string;
}

export type ITileLink = ILink & ITileLinkBase;
